export default __webpack_public_path__ + "static/media/elipse.40cce636.svg";